import { Component, ElementRef, OnInit } from '@angular/core';

import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';

import axios from 'src/app/Service/axios';

import { NotificationService } from 'src/app/Service/notification.service';

import { OtherService } from 'src/app/Service/other.service';

import { Location } from '@angular/common';

import momentJalaali from 'moment-jalaali';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

declare let $: any;

@Component({

  selector: 'Repairs',

  templateUrl: './repairs.component.html',

})

export class RepairsComponent implements OnInit {

  constructor(

    private el: ElementRef,

    private notifyService: NotificationService,

    private router: Router,

    public otherService: OtherService,

    private route: ActivatedRoute,

    private formBuilder: FormBuilder,

    private _location: Location,

    private gurdService: GurdServiceService

  ) { }

  Id: number = 0;

  Repairs: any;

  currentDate: any;

  loggedinUserName: string | null = this.gurdService.decrypt(localStorage.getItem('FullName')!);

  vehicle: any = {};

  EditeMod: boolean = false;

  summeryReview: any = {};

  fLastKM: number = 0;

  list_RepairType = [];

  lstMdlRepairMaintenance: any[] = [];

  acssess: any;

  datatTa: FormGroup = this.formBuilder.group({

    date: new FormControl(''),

  })

  dataAz: FormGroup = this.formBuilder.group({

    date: new FormControl(''),
  })

  datasabt: FormGroup = this.formBuilder.group({

    date: new Date().valueOf(),

  })

  serchModel: FormGroup = this.formBuilder.group({

    reson: new FormControl(),

    repairer: new FormControl(),

  })

  sabtModel: FormGroup = this.formBuilder.group({

    iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    strUnitId: new FormControl(''),

    strReason: new FormControl(''),

    strRepairman: new FormControl(''),

    strComment: new FormControl(''),

    iKM: new FormControl(''),

    iTotalCost: new FormControl(''),

    iRepairMaintenanceRecord: new FormControl(''),

    strImage: new FormControl('')

  })

  ngOnInit(): void {

    var data = window.localStorage.getItem("menu") as any;
    this.acssess = JSON.parse(this.gurdService.decrypt(data));
    this.currentDate = momentJalaali().locale('fa').format('jYYYY/jMM/jDD');
    this.vehicle.ownerName = this.gurdService.decrypt(localStorage.getItem('carName')!);
    this.vehicle.plate = this.gurdService.decrypt(localStorage.getItem('plate')!);
    this.vehicle.plate = this.vehicle.plate.split(',').join().replaceAll(',', ' ');
    this.vehicle.hoze = this.gurdService.decrypt(localStorage.getItem('hze')!);
    this.vehicle.vin = this.gurdService.decrypt(localStorage.getItem('vin')!);
    $('#exampleModal').on('hidden.bs.modal', () => {
      this.close();
    })

    this.route.params.subscribe((params) => {
      this.Id = params['id'];
      this.getFlastKM()
      // this.sabtModel.controls['strUnitId'].setValue(this.Id);
    });
    this.getAllRepairs();

    this.getRepairMaintenanceType()
  }

  goBack() {
    this._location.back();
  }

  getAllRepairs = async (
    strSDate?: string,
    strEDate?: string,
    strRepairman?: string,
    strReason?: string
  ) => {
    this.otherService.Showspinner();
    const session = encodeURIComponent(this.gurdService.decrypt(window.localStorage.getItem('Session')!));
    const resp = await axios.post(
      `GetRepairMaintenanceRecordNew?strUnitID=${this.Id
      }&strSDate=${strSDate == undefined ? '' : strSDate}&strEDate=${strEDate == undefined ? '' : strEDate
      }&strRepairman=${strRepairman == undefined ? '' : strRepairman
      }&strReason=${strReason == undefined ? '' : strReason
      }&strSession=${session}`
    );
    this.otherService.nonespinner();
    if (resp.data[0] && resp.data[0].ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login']);
      return;
    }
    if (resp.data.length == 0) {
      this.notifyService.showInfo('داده ای برای نمایش موجود نیست', '');
      this.Repairs = resp.data;

    } else {
      this.Repairs = resp.data;
      this.summeryReview.totalCost = 0;
      this.Repairs.forEach((element: any) => {
        this.summeryReview.totalCost += element.iTotalCost
      });
    }
  }

  sabt = async () => {

    var model = this.sabtModel.value;

    model.strDate = this.datasabt.value.date;

    model.strUnitId = this.Id;

    model.lstmdlRepairMaintenance_Save = this.lstMdlRepairMaintenance;

    if (model.iTotalCost != null && model.iTotalCost != '' && model.iTotalCost != 0) {

      model.iTotalCost = parseFloat(model.iTotalCost.replace(/,/g, ''));

    }

    // if (model.iKM != null && model.iKM != '' && model.iKM != 0) {

    //   model.iKM = parseFloat(model.iKM.replace(/,/g, ''));

    // }

    if ((model.iTotalCost == null || model.iTotalCost == '' || model.iTotalCost == 0) && (model.strReason == null || model.strReason == '')) {

      this.notifyService.showError('لطفا مقدار هزینه  یا موضوع را وارد کنید');

      return;
    }

    if (confirm('آیا از ثبت اطلاعات اطمینان دارید؟')) {

      model.lstmdlRepairMaintenance_Save.forEach((item: any, index: number) => {

        if (item.iCost != null && item.iCost.toString().trim() != '' && item.iCost != 0 && item.iCost.toString().includes(',')) {

          model.lstmdlRepairMaintenance_Save[index].iCost = model.lstmdlRepairMaintenance_Save[index].iCost?.replace(/,/g, '');

        }

      })

      const resp: any = await axios.post(`RepairMaintenanceRecordNew_Save`, model);

      let res = JSON.parse(resp.data)

      if (resp?.data == -100) {

        this.notifyService.showError('لطفا وارد سیستم شوید');

        this.otherService.removeLocalStorage();

        // this.router.navigate(['/login']);

        this.router.navigate(['/login'], { queryParams: { ERR_CODE: 1 } });

        return;
      }

      if (resp?.data == -1) {

        this.notifyService.showError('خطایی رخ داده');

      }

      if (res.iResult == 0) {

        return this.notifyService.showError(res.str)

      }

      if (res.iResult == 1) {

        this.notifyService.showSuccess('با موفقیت ثبت شد');

        this.getAllRepairs();

        $('#exampleModal').modal('hide');

      }

    }

  }

  serch() {
    var model = this.serchModel.value;
    this.getAllRepairs(
      this.dataAz.value.date,
      this.datatTa.value.date,
      model.repairer,
      model.reson
    );
  }

  getSeparatedValue(input: any) {
    return new Number(input).toLocaleString('fa-ir')
  }

  getSingel = async (Id: any) => {

    this.datasabt.controls['date'].setValue(this.Repairs[Id].strDate);

    this.sabtModel.controls['strReason'].setValue(this.Repairs[Id].strReason);

    this.sabtModel.controls['strComment'].setValue(this.Repairs[Id].strComment);

    this.sabtModel.controls['strImage'].setValue(this.Repairs[Id].strImage);

    this.sabtModel.controls['strRepairman'].setValue(

      this.Repairs[Id].strRepairman

    );

    this.sabtModel.controls['iKM'].setValue(

      this.Repairs[Id].iKM

      // .toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")

      // .toLocaleString()

    );

    this.sabtModel.controls['iTotalCost'].setValue(

      this.Repairs[Id].iTotalCost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")

    );

    this.sabtModel.controls['iRepairMaintenanceRecord'].setValue(

      this.Repairs[Id].iRepairMaintenanceRecord

    );

    this.lstMdlRepairMaintenance = [];

    this.initial_ServiceType(true)

    $('#exampleModal').modal('show');

    this.EditeMod = true;
  }

  edit = async () => {

    var model = this.sabtModel.value;

    model.strDate = this.datasabt.value.date;

    model.strUnitId = this.Id;

    model.lstmdlRepairMaintenance_Save = this.lstMdlRepairMaintenance;

    if (model.iTotalCost != null && model.iTotalCost != '' && model.iTotalCost != 0) {

      model.iTotalCost = parseFloat(model.iTotalCost.toString().replace(/,/g, ''));

    }

    // if (model.iKM != null && model.iKM != '' && model.iKM != 0) {

    //   model.iKM = parseFloat(model.iKM.replace(/,/g, ''));

    // }

    if ((model.iTotalCost == null || model.iTotalCost == '' || model.iTotalCost == 0) && (model.strReason == null || model.strReason == '')) {

      this.notifyService.showError('لطفا مقدار هزینه  یا موضوع را وارد کنید');

      return;
    }

    if (confirm('آیا از ویرایش اطلاعات اطمینان دارید؟')) {

      model.lstmdlRepairMaintenance_Save.forEach((item: any, index: number) => {

        if (item.iCost != null && item.iCost.toString().trim() != '' && item.iCost != 0 && item.iCost.toString().includes(',')) {

          model.lstmdlRepairMaintenance_Save[index].iCost = model.lstmdlRepairMaintenance_Save[index].iCost?.replace(/,/g, '');

        }

      })

      const resp: any = await axios.post(`RepairMaintenanceRecordNew_Update`, model);

      let res = JSON.parse(resp.data)

      if (resp.data == -100) {
        this.notifyService.showError('لطفا وارد سیستم شوید');
        this.otherService.removeLocalStorage();
        // this.router.navigate(['/login']);
        this.router.navigate(['/login'], { queryParams: { ERR_CODE: 2 } });
        return;
      }

      if (res.iResult == 0) {

        return this.notifyService.showError(res.str)

      }

      if (res.iResult == 1) {

        this.notifyService.showSuccess('با موفقیت ویرایش شد');

        this.getAllRepairs();

        this.EditeMod = false;

        $('#exampleModal').modal('hide');

      }

    }

  }

  deleteRepair = async () => {
    if (confirm('آیا از حذف اطلاعات اطمینان دارید؟')) {
      var Id = this.sabtModel.value.iRepairMaintenanceRecord;
      const session = encodeURIComponent(this.gurdService.decrypt(window.localStorage.getItem('Session')!));
      const resp = await axios.post(
        `DeleteRepairMaintenanceRecord?iRepairMaintenanceRecord=${Id}&iSystemUser=${this.gurdService.decrypt(window.localStorage.getItem('ID')!)}&strSession=${session}`
      );
      if (resp.data == -100) {
        this.notifyService.showError('لطفا وارد سیستم شوید');
        this.otherService.removeLocalStorage();
        // this.router.navigate(['/login']);
        this.router.navigate(['/login'], { queryParams: { ERR_CODE: 3 } });
        return;
      }
      if (resp.data == -1) {
        this.notifyService.showError('خطایی رخ داده');
        this.sabtModel.reset({
          strReason: '',
          strRepairman: '',
          strComment: '',
        });
      }
      if (resp.data == 1) {
        this.notifyService.showSuccess('با موفقیت جذف شد');
        $('#exampleModal').modal('hide');

        this.Repairs = this.Repairs.filter(function (el: any) {
          return el.iRepairMaintenanceRecord != Id;
        });
      }
    }
  }

  seprator(e: any) {

    if (isNaN(e.key)) return false;

    this.otherService.insertComma(e);

    return true;
  }

  close() {

  }

  open() {

    this.sabtModel.patchValue({

      strReason: "",

      strRepairman: "",

      strComment: "",

      iKM: "",

      iTotalCost: "",

      iRepairMaintenanceRecord: "",

      strImage: ""

    })

    this.datasabt.reset({

      date: momentJalaali().format('jYYYY/jMM/jDD'),

    });

    this.sabtModel.controls['iKM'].setValue(this.fLastKM);

    this.lstMdlRepairMaintenance = [];

    this.EditeMod = false;

  }

  guid(Id: any) {
    this.otherService.guid(Id);
  }

  onFileInput(file: any) {

    let extension = file.name.split('.').pop();

    if (extension !== 'jpeg' && extension !== 'jpg') this.notifyService.showError(' فرمت قابل قبول فقط jpg است')

    if (extension === 'jpeg' || extension === 'jpg') {

      const reader: any = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = async () => {

        var base64String = reader.result.toString();

        base64String = base64String.replace('data:image/jpeg;base64,', '');

        this.sabtModel.controls['strImage'].setValue(base64String)

      };

    }


  }

  getFlastKM = async () => {

    var model = {

      ID: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    };

    const resp = await axios.post(`GetCar?strUnitID=${this.Id}`, model);

    if (resp.data.ISSessionExpired == true) {

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;

    }

    if (resp.data == null) return this.notifyService.showError('بروز خطا در سامانه');


    this.fLastKM = resp.data.fLastKM;

  }

  getRepairMaintenanceType = async () => {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    };

    const resp = await axios.post(`RepairMaintenanceType`, model);

    if (resp.data.ISSessionExpired == true) {

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;

    }

    if (resp.data == null) return this.notifyService.showError('بروز خطا در سامانه');


    this.list_RepairType = resp.data;

  }

  openServiceType_Modal = async () => {

    if (!this.EditeMod) {

      this.list_RepairType.forEach((a: any) => {

        this.lstMdlRepairMaintenance.push({

          'iRepairMaintenanceType': a.iRepairMaintenanceType,

          'strTitle': a.strComment,

          'iCost': '',

          'strComment': '',

          'tiStatus': 0,

          'bExpanded': false

        })

      })

      $("#exampleModal").modal('hide')

      $("#serviceType_Modal").modal('show')

    }

    if (this.EditeMod) {

      $("#exampleModal").modal('hide')

      this.initial_ServiceType();

    }

  }

  backToSave() {

    $("#exampleModal").modal('show')

    $("#serviceType_Modal").modal('hide')

  }

  setStatus_ServiceType(index: number, tiStatus: number) {

    this.lstMdlRepairMaintenance[index].tiStatus = tiStatus;

  }

  initial_ServiceType = async (bNotShow?: boolean) => {

    if (this.lstMdlRepairMaintenance.length) {

      $("#serviceType_Modal").modal('show')

    }

    if (!this.lstMdlRepairMaintenance.length) {

      this.otherService.Showspinner();

      const resp = await axios.post(`RepairMaintenance_List`, this.sabtModel.value);

      let res = JSON.parse(resp.data);

      if (res.length) {

        res.forEach((a: any) => {

          this.lstMdlRepairMaintenance.push({

            'iRepairMaintenanceType': a.iRepairMaintenanceType,

            'strTitle': a.strRepairMaintenanceType_strComment,

            'iCost': a.iCost == 0 ? '' : a.iCost,

            'strComment': a.strComment,

            'tiStatus': a.tiStatus,

            'bExpanded': (a.iCost != 0 || a.strComment.trim() != '') ? true : false

          })

        })

      }

      if (!res.length) {

        this.list_RepairType.forEach((a: any) => {

          this.lstMdlRepairMaintenance.push({

            'iRepairMaintenanceType': a.iRepairMaintenanceType,

            'strTitle': a.strComment,

            'iCost': '',

            'strComment': '',

            'tiStatus': 0,

            'bExpanded': false

          })

        })

      }

      if (!bNotShow) {

        $("#serviceType_Modal").modal('show')

      }

      this.otherService.nonespinner()

    }

  }

  fullScreen_Image() {

    const image_Element = $("#fullScreen_");

    image_Element.toggleClass('full-screen');

  }

}
